import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const API_KEY = process.env.REACT_APP_API_KEY || 'premo_api_secure_key_2025';



// Create a single axios instance to be used across all services
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 60 * 1000, // 60 seconds timeout
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
    }
});

// Interceptor to add authorization token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        // Always ensure API key is included
        config.headers['X-API-Key'] = API_KEY;
    
        
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor to handle token expiration
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        // Check if error is due to authentication and we haven't already tried to refresh
        if (error.response && 
            (error.response.status === 401 || error.response.status === 403) &&
            !originalRequest._retry) {
            
            originalRequest._retry = true;
          
            
            // Clear tokens on authentication errors
            localStorage.removeItem('token');
            localStorage.removeItem('premo_password');
            
            // Don't redirect here - let the components handle the redirect
            // This prevents infinite redirect loops
        }
        
        return Promise.reject(error);
    }
);

export default api;
